










import Vue from 'vue';
import { openModal } from 'mycorems-app-shared';
import isGranted from '@/auth/isGranted';
import EditClientModal from './EditClientModal.vue';

export default Vue.extend({
  props: {
    client: {
      type: Object as () => Account,
      required: true,
    },
  },
  methods: {
    editAccount(): void {
      openModal(EditClientModal, {
        client: this.client,
      });
    },
    isGranted,
  },
});
